import { get } from "lodash";

// Contains a list of pages to track internal users on. Simple includes check in URL path so its better to be specific
const WHITE_LIST = ["/admin/product_matching_queue", "/admin/product_match_maker"];

export function shouldNotTrack() {
  return (
    (isBadUser() || isAdmin() || isInternal() || isSupplier() || isSalesRep()) &&
    window.RAILS_ENV === "production" &&
    !isOnWhiteListPage()
  );
}

export const isOnWhiteListPage = () => {
  for (const url of WHITE_LIST) {
    if (window.location.href.includes(url)) {
      return true;
    }
  }

  return false;
};

export function isSupplier() {
  let role = ($rootScope.user || {}).role;
  return role === "supplier";
}

export function isSalesRep() {
  let role = ($rootScope.user || {}).role;
  return role === "sales_rep";
}

export function isInternal(email) {
  let emailDomains = ["@provi.com", "@getprovi.com"];
  let userEmail = email || get($rootScope, "user.email", "") || "";
  return emailDomains.some(x => userEmail.endsWith(x));
}

export function isAdmin() {
  let tuid = ($rootScope.trueUser || {}).id;
  let uid = ($rootScope.user || {}).id;
  let propCheck = ($rootScope.trueUser || {}).admin || ($rootScope.user || {}).admin
  if (tuid && uid) {
    return (tuid !== uid) || propCheck;
  } else {
    return propCheck;
  }
}

export function shouldNotTrackAnywhere() {
  return (isAdmin() || isInternal())
}

export function isBadUser() {
  let uid = ($rootScope.user || {}).id;
  return uid === 42164 || uid === 66606;
}
